"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRemaintNuclearMaintenanceConcept = function IconRemaintNuclearMaintenanceConcept(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11 18h2V7h18.2l.232.007a3.8 3.8 0 0 1 2.455 1.106l.159.169A3.8 3.8 0 0 1 35 10.8V41H24v2h13V10.8l-.006-.27A5.8 5.8 0 0 0 31.2 5H11zm15-2v-1h-9v1zm2-4v1H17v-1zM12.164 43.55l-.84.834a24 24 0 0 1-1.68-1.15l1.103-1.095a4.9 4.9 0 0 1 3.788-1.456 9.73 9.73 0 0 0 10.15-12.153l-.04-.141-5.497 5.498a3 3 0 0 1-1.925.873l-.198.007a3 3 0 0 1-1.977-.744l-.145-.136-2.47-2.47a3 3 0 0 1-.136-4.1l.136-.144 5.528-5.53-.162-.047a9.73 9.73 0 0 0-7.806 1.228l-.277.186a9.74 9.74 0 0 0-4.138 8.764 4.9 4.9 0 0 1-1.269 3.575l-.182.188-.748.749a24 24 0 0 1-.991-1.838l.331-.331a2.9 2.9 0 0 0 .864-2.21 11.73 11.73 0 0 1 16.28-11.71l.326.145 1.303.6-7.645 7.645a1 1 0 0 0-.087 1.317l.087.099 2.47 2.47a1 1 0 0 0 1.317.087l.099-.087 7.634-7.634.595 1.32a11.73 11.73 0 0 1-11.558 16.52 2.9 2.9 0 0 0-2.087.726z",
    clipRule: "evenodd"
  })));
};

export { IconRemaintNuclearMaintenanceConcept, IconRemaintNuclearMaintenanceConcept as default };
